import script from "./my-highlight-text.vue?vue&type=script&setup=true&lang=js"
export * from "./my-highlight-text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__